import { Divider, styled } from '@mui/material'

export const SubHeaderDivider = styled(props => (
  <Divider {...props} orientation="vertical" />
))({ height: '18px' })
